/* INDIGREY — homepage flat-lay strip behaviours (hint + outside-touch reset).

   1) SWIPE HINT, triggered ON VIEW: the block's own hint fires on
      page-load timers, but the carousel sits below the fold — it played
      invisibly and burned its once-per-session flag before anyone saw it.
      This version waits until the first flat-lay card is 60% visible,
      pauses 450ms so the shopper has settled, then nudges the strip twice
      (peek → back → peek → back) and only THEN marks the session as
      shown. Cancels the instant the shopper interacts. ?swipeDemo=1
      replays for testing.

   2) OUTSIDE-TOUCH RESET: a card whose strip has been swiped away from
      the flat-lay eases back to it the moment the shopper touches or
      clicks anywhere OUTSIDE that card — so at most one card is ever
      "open" and the shelf always returns to its resting flat-lay state.

   Both use a deterministic rAF glide (native smooth scroll is throttled
   unpredictably); snap is suspended during the glide, restored after. */
(function () {
  function glide(strip, left) {
    var from = strip.scrollLeft;
    var to = Math.max(0, left);
    var d = to - from;
    if (strip._igGlideR) cancelAnimationFrame(strip._igGlideR);
    if (!d) return;
    strip.style.scrollSnapType = 'none';
    var t0 = null;
    var DUR = 340;
    function ease(p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
    function tick(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      strip.scrollLeft = from + d * ease(p);
      if (p < 1) {
        strip._igGlideR = requestAnimationFrame(tick);
      } else {
        strip._igGlideR = null;
        strip.style.scrollSnapType = '';
      }
    }
    strip._igGlideR = requestAnimationFrame(tick);
  }

  /* ---- outside-touch reset ---- */
  function setupOutsideReset() {
    if (!document.querySelector('.ai-carousel-flatlay-card')) return;
    document.addEventListener('pointerdown', function (e) {
      var touchedCard = e.target && e.target.closest ? e.target.closest('.ai-carousel-flatlay-card') : null;
      document.querySelectorAll('.ai-carousel-flatlay-card').forEach(function (wrapper) {
        if (wrapper === touchedCard) return;                 /* the card being used keeps its frame */
        var strip = wrapper.querySelector('[data-flatlay-strip]');
        if (!strip || strip.scrollLeft < 2) return;          /* already resting on the flat-lay */
        glide(strip, 0);
      });
    }, true);
  }

  /* ---- swipe hint on view ---- */
  function setupHint() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !window.sessionStorage) return;
    var force = window.location.search.indexOf('swipeDemo') !== -1;
    if (sessionStorage.getItem('ig_home_hint_v2') && !force) return;
    var strip = document.querySelector('.ai-carousel-flatlay-card [data-flatlay-strip]');
    if (!strip) return;
    var wrapper = strip.closest('.ai-carousel-flatlay-card');
    var played = false;
    var timers = [];
    function detach() {
      window.removeEventListener('touchstart', cancel, true);
      window.removeEventListener('pointerdown', cancel, true);
      window.removeEventListener('wheel', cancel, true);
    }
    function cancel() {
      timers.forEach(clearTimeout);
      timers = [];
      glide(strip, 0);
      detach();
    }
    function play() {
      if (played) return;
      played = true;
      if (!force) sessionStorage.setItem('ig_home_hint_v2', '1');
      window.addEventListener('touchstart', cancel, true);
      window.addEventListener('pointerdown', cancel, true);
      window.addEventListener('wheel', cancel, true);
      [[0, 22], [340, 0], [680, 22], [1020, 0]].forEach(function (p) {
        timers.push(setTimeout(function () { glide(strip, p[1]); }, p[0]));
      });
      timers.push(setTimeout(detach, 1400));
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            io.disconnect();
            setTimeout(play, 450);
          }
        });
      }, { threshold: [0.6] });
      io.observe(wrapper);
    } else {
      setTimeout(play, 1200);
    }
  }

  function boot() {
    setupOutsideReset();
    setupHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
